module.exports = "images/apple-icon-152x152.afd04ce08ef8e8fdc48250a25c23ebc3.png";